var map = {
	"./s1.png": "b5d2",
	"./s2.png": "493d",
	"./s3.png": "635a",
	"./s4.png": "619c",
	"./s5.png": "1d9f",
	"./s6.png": "2467",
	"./s7.png": "a8f8",
	"./s8.png": "bd01"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a752";